/**
 * Mainbeauty — popup "Nhận tư vấn miễn phí" cho mọi [data-pi-consult-open].
 */
import { bindPopupClose, closePopupOnLead, focusFirstField } from "./mainbt-popup-form.js";

function initConsultPopup() {
  const popup = document.querySelector("[data-pi-consult]");
  if (!popup) return;

  const isOpen = () => popup.classList.contains("is-open");

  const open = () => {
    popup.classList.add("is-open");
    document.body.classList.add("pi-noscroll");
    focusFirstField(popup);
  };

  const close = () => {
    popup.classList.remove("is-open");
    document.body.classList.remove("pi-noscroll");
  };

  // href="#dangky" của CTA giữ nguyên làm fallback khi tắt JS.
  document.addEventListener("click", (e) => {
    const trigger = e.target.closest("[data-pi-consult-open]");
    if (!trigger) return;
    e.preventDefault();
    open();
  });

  bindPopupClose(popup, "[data-pi-consult-box]", "[data-pi-consult-close]", close);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && isOpen()) close();
  });

  // Gửi thành công: nhường chỗ cho modal thông báo chung, dọn form cho lần sau.
  closePopupOnLead(popup, close);
}

document.addEventListener("DOMContentLoaded", initConsultPopup);
